import { Component, OnInit, ViewChild, OnDestroy, TemplateRef, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ConsultaImportacaoFuncionariosService } from './consulta-importacao-funcionarios.service';
import { Location } from '@angular/common';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { DatatableService } from '../../../../../shared/services/datatable.service';
import { IMyDpOptions } from 'mydatepicker';
import { HttpParams } from '@angular/common/http';
import { SpringDatatablePaginationService } from '../../../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { SpringDatatablePagination } from '../../../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { ActivatedRoute } from '@angular/router';
import { EncriptyUtilService } from '../../../../../shared/services/encripty-util.service';
import { NbDialogService } from '@nebular/theme';
import { ObservacaoImportacaoFuncionarioComponent } from './observacao-importacao-funcionario/observacao-importacao-funcionario.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'ngx-consulta-importacao-funcionarios',
  templateUrl: './consulta-importacao-funcionarios.component.html',
  styleUrls: ['./consulta-importacao-funcionarios.component.scss']
})
export class ConsultaImportacaoFuncionariosComponent implements OnInit, OnDestroy,AfterViewInit {

  arquivoId = null;
  spinnerLoad: boolean = false;
  tableLimit = 10;
  public formSearch: FormGroup = null;
  public listStatus = [];

  public yesterday = new Date((new Date()).valueOf() - 1000*60*60*24);

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
    disableUntil: { year: this.yesterday.getFullYear(), month: this.yesterday.getMonth() + 1, day: this.yesterday.getDate() },
  };


  @ViewChild('myTable', null)
  public myTable: DatatableComponent;
  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();

  constructor(
    private location: Location,
    private datatableService: DatatableService,
    private service: ConsultaImportacaoFuncionariosService,
    private formBuilder: FormBuilder,
    private paginationService: SpringDatatablePaginationService,
    private activatedRoute: ActivatedRoute,
    private encriptyService: EncriptyUtilService,
    private dialogService: NbDialogService,
    private cdRef: ChangeDetectorRef,
    private spinnerService: NgxSpinnerService,
    private notificationService: NotificationsService,

  ) {
    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.activatedRoute.queryParamMap.subscribe(params => {
      this.arquivoId = this.encriptyService.decriptyBySecretKey(params.get('arquivoId'));
    });

    this.service.searchImportEmployeeStatus(null, (response) => {
      this.listStatus = response;
    }, null);
  }

  ngOnInit() {
    this.datatableService.subscribeTable(this.myTable);

    this.formSearch = this.formBuilder.group({
      nome: [null],
      cpf: [null],
      matricula: [null],
      status: [null]
    });

    this.fillEmployeeImport(this.formSearch.value);
  }

  ngAfterViewInit() {

    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    this.datatableService.unsubscribeTable(this.myTable);
  }

  fillEmployeeImport(data?: any, page?: string) {
    let path: any = this.arquivoId;
    let params = new HttpParams();
    params = params.append('size', String(this.tableLimit));
    params = params.append('sort', 'id,asc');

    if (page) {
      params = params.append('page', page);
    }

    if (data) {


      if (data.nome != null && String(data.nome).trim() !== '') {
        params = params.append('nome', data.nome);
      }

      if (data.cpf != null) {
        params = params.append('cpf', data.cpf);
      }

      if (data.matricula != null) {
        params = params.append('matricula', data.matricula);
      }

      if (data.status != null) {
        params = params.append('status', data.status);
      }
    }

    this.spinnerService.show();
    this.service.searchImportEmployee(path, params, (response) => {
      let data: any = response.content.map((line) => {
        return {
        nome: line.nome,
        cpf: line.cpf,
        matricula: line.matricula,
        email: line.email,
        cargo: line.cargo,
        produto: line.produto == 'SALARIO' ? 'PAGAMENTO' : line.produto,
        status: line.status,
        observacaoProcessamento: line.observacaoProcessamento,
      }})
      response.content = data;
      this.paginationService.setInfo(response);
      this.spinnerService.hide();

    }, (error) => {
      this.notificationService.error("Não foi possível carregar as informações.")
      this.spinnerService.hide();
    });
  }

  showObservation(observationText: any) {


      this.dialogService.open(ObservacaoImportacaoFuncionarioComponent, {
        context: {
          content: observationText,
        },
      });

  }

  openWithoutBackdrop(dialog: TemplateRef<any>, content:any) {
    this.dialogService.open(
      dialog,
      {
        context: content,
        hasBackdrop: false,
      });
  }

  previousPage() {
    this.location.back();
  }
}
